import { createFileRoute, useSearch } from '@tanstack/react-router'
import { z } from 'zod'
import { ConfirmEmailScreen } from '@/features/auth/routes/confirm-email-screen'

// The token rides in the query string, not the path, so page-view analytics
// (which record the path only) never see it.
const searchSchema = z.object({ token: z.string().optional() })

export const Route = createFileRoute('/confirm-email')({
  validateSearch: searchSchema,
  component: ConfirmEmailRoute,
})

function ConfirmEmailRoute() {
  const { token } = useSearch({ from: '/confirm-email' })
  return <ConfirmEmailScreen token={token ?? null} />
}
